<template>
    <v-stepper v-model="step" class="password-stepper">
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1" color="greenMain">
                Request Password Change
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2" color="greenMain">
                Email address
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 3" step="3" color="greenMain">
                Verify OTP
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4" color="#708AA7"
                >Change Password
            </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                    class="deposit-form mb-3"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <div class="flexbox">
                                <div>
                                    <v-icon color="#FF567F"
                                        >mdi mdi-lock-open-outline</v-icon
                                    >
                                </div>
                                <div class="ml-3">
                                    <v-card-title class="mt-1 text-red">
                                        Change Your Password
                                    </v-card-title>
                                    <v-card-text class="pb-0">
                                        <p>Request New Password</p>
                                    </v-card-text>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    class="deposit-form"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <v-card-title> Request New Password </v-card-title>
                            <v-card-text>
                                <p>
                                    You will receive a OTP by email to <br />
                                    authorize your password change request.
                                </p>
                            </v-card-text>
                            <v-card-actions class="pa-0">
                                <v-btn
                                    class="text-capitalize btn-account"
                                    width="256"
                                    color="greenMain"
                                    tile
                                    elevation="0"
                                    @click="changeNextStep(2)"
                                >
                                    Next
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card
                    class="deposit-form mb-3"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <div class="flexbox">
                                <div>
                                    <v-icon color="#FF567F"
                                        >mdi mdi-lock-open-outline</v-icon
                                    >
                                </div>
                                <div class="ml-3">
                                    <v-card-title class="mt-1 text-red">
                                        Change Your Password
                                    </v-card-title>
                                    <v-card-text class="pb-0">
                                        <p>Request New Password</p>
                                    </v-card-text>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    class="deposit-form"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <v-card-title>Verified Email Address </v-card-title>
                            <v-card-text>
                                <p class="bg-timer">
                                    You will receive a One-Time Password (OTP)
                                    at this email address.
                                </p>
                            </v-card-text>
                            <fieldset>
                                <legend>Your Email</legend>
                                <v-text-field
                                    label="Enter Here"
                                    single-line
                                    solo
                                    hide-details
                                    class="custom-select"
                                    readonly
                                    :value="client.email"
                                ></v-text-field>
                            </fieldset>
                            <v-card-actions class="pa-0">
                                <v-btn
                                    class="text-capitalize btn-account"
                                    width="256"
                                    color="greenMain"
                                    tile
                                    elevation="0"
                                    @click.prevent="handleReset"
                                >
                                    Next
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
                <v-card
                    class="deposit-form mb-3"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <div class="flexbox">
                                <div>
                                    <v-icon color="#FF567F"
                                        >mdi mdi-lock-open-outline</v-icon
                                    >
                                </div>
                                <div class="ml-3">
                                    <v-card-title class="mt-1 text-red">
                                        Change Your Password
                                    </v-card-title>
                                    <v-card-text class="pb-0">
                                        <p>Request New Password</p>
                                    </v-card-text>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    class="deposit-form"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col style="position: relative">
                            <v-card-title> Enter OTP </v-card-title>
                            <v-card-text>
                                <p class="bg-timer">
                                    Please be advised that you have
                                    {{ formattedTime }} minutes remaining to
                                    authorize your password change request.
                                    Thank you for your prompt attention.
                                </p>
                            </v-card-text>
                            <fieldset>
                                <legend>Enter OTP</legend>
                                <v-text-field
                                    label="Enter Here"
                                    single-line
                                    solo
                                    hide-details
                                    class="custom-select"
                                    type="number"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                    @input="RESET_CODE"
                                ></v-text-field>
                            </fieldset>
                            <v-card-actions class="pa-0">
                                <v-btn
                                    v-if="formattedTime === '0:00'"
                                    class="text-capitalize btn-account mr-2"
                                    width="256"
                                    color="greenMain"
                                    tile
                                    elevation="0"
                                    @click.prevent="resendOTP"
                                >
                                    Resend OTP
                                </v-btn>
                                <v-btn
                                    v-if="formattedTime !== '0:00'"
                                    class="text-capitalize btn-account"
                                    width="256"
                                    color="greenMain"
                                    tile
                                    elevation="0"
                                    @click.prevent="handleCodeVerify"
                                >
                                    Verify OTP
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="4">
                <v-card
                    class="deposit-form mb-3"
                    max-width="612px"
                    :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
                >
                    <v-row>
                        <v-col>
                            <div class="flexbox">
                                <div>
                                    <v-icon color="#FF567F"
                                        >mdi mdi-lock-open-outline</v-icon
                                    >
                                </div>
                                <div class="ml-3">
                                    <v-card-title class="mt-1 text-red">
                                        Change Your Password
                                    </v-card-title>
                                    <v-card-text class="pb-0">
                                        <p>Request New Password</p>
                                    </v-card-text>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    class="deposit-form password-field"
                    max-width="612px"
                    :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'"
                >
                    <v-row>
                        <v-col>
                            <v-card-title> Enter New Password </v-card-title>
                            <!-- <v-card-text>
                <p>
                  You will receive a OTP by email to <br />
                  authorize your password change request.
                </p>
              </v-card-text> -->
                            <fieldset>
                                <legend>New Password</legend>
                                <v-text-field
                                    label="Enter Here"
                                    @input="RESET_NEWPASS"
                                    v-model="new_password"
                                    :append-icon="
                                        show1 ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :type="show1 ? 'text' : 'password'"
                                    counter
                                    @click:append="show1 = !show1"
                                    single-line
                                    solo
                                    hide-details
                                    class="custom-select"
                                ></v-text-field>
                            </fieldset>
                            <div class="tick-mark justify-start">
                                <span>
                                    <v-icon
                                        small
                                        :class="
                                            hasMinimumLength
                                                ? 'text--green'
                                                : 'text--primary'
                                        "
                                        >mdi mdi-check</v-icon
                                    >8 Characters
                                </span>
                                <span>
                                    <v-icon
                                        small
                                        :class="
                                            hasLowerCase
                                                ? 'text--green'
                                                : 'text--primary'
                                        "
                                        >mdi mdi-check</v-icon
                                    >1 Lowercase
                                </span>
                                <span>
                                    <v-icon
                                        small
                                        :class="
                                            hasUpperCase
                                                ? 'text--green'
                                                : 'text--primary'
                                        "
                                        >mdi mdi-check</v-icon
                                    >1 Uppercase
                                </span>
                                <span>
                                    <v-icon
                                        small
                                        :class="
                                            hasDigit
                                                ? 'text--green'
                                                : 'text--primary'
                                        "
                                        >mdi mdi-check</v-icon
                                    >1 Digit
                                </span>
                                <span>
                                    <v-icon
                                        small
                                        :class="
                                            hasSpecialCharacter
                                                ? 'text--green'
                                                : 'text--primary'
                                        "
                                        >mdi mdi-check</v-icon
                                    >1 Special Character
                                </span>
                            </div>
                            <fieldset>
                                <legend>Confirm Password</legend>
                                <v-text-field
                                    label="Re-type new password"
                                    @input="RESET_REPEATPASS"
                                    v-model="confirm_password"
                                    :append-icon="
                                        show2 ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :type="show2 ? 'text' : 'password'"
                                    counter
                                    @click:append="show2 = !show2"
                                    @copy="onCopy"
                                    @paste="onPaste"
                                    single-line
                                    solo
                                    hide-details
                                    class="custom-select"
                                    ref="passwordField"
                                ></v-text-field>
                            </fieldset>
                            <v-card-actions class="pa-0">
                                <v-btn
                                    class="ma-0 text-capitalize btn-account"
                                    color="greenMain"
                                    tile
                                    elevation="0"
                                    :disabled="!allConditionsMet"
                                    @click.prevent="handlePassReset"
                                >
                                    Save Password
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { AUTHENTICATION__ACTIONS } from "@/store/action-types";
import { AUTHENTICATION__MUTATIONS } from "@/store/mutation-types";

export default {
    name: "ChangePasswordView",
    data() {
        return {
            show1: false,
            show2: false,
            password: "",
            password2: "",
            countdownTime: 120,
            new_password: "",
            confirm_password: "",
            hasMinimumLength: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasDigit: false,
            hasSpecialCharacter: false,
        };
    },
    computed: {
        ...mapState("profile", ["client"]),
        ...mapState("authentication", ["resetInfo", "step"]),
        formattedTime() {
            const minutes = Math.floor(this.countdownTime / 60);
            const seconds = this.countdownTime % 60;
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        },
        allConditionsMet() {
            return (
                this.hasMinimumLength &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasDigit &&
                this.hasSpecialCharacter &&
                this.new_password &&
                this.confirm_password &&
                this.new_password===this.confirm_password
            );
        },
    },
    watch: {
        new_password: function () {
            this.hasMinimumLength = this.new_password.length >= 8;
            this.hasLowerCase = /.*[a-z].*/.test(this.new_password);
            this.hasUpperCase = /.*[A-Z].*/.test(this.new_password);
            this.hasDigit = /.*\d.*/.test(this.new_password);
            this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(
                this.new_password
            );
        },
    },
    methods: {
        ...mapMutations("authentication", {
            RESET_CODE: AUTHENTICATION__MUTATIONS.RESET_CODE,
            RESET_NEWPASS: AUTHENTICATION__MUTATIONS.RESET_NEWPASS,
            RESET_REPEATPASS: AUTHENTICATION__MUTATIONS.RESET_REPEATPASS,
            CHANGESTEP: AUTHENTICATION__MUTATIONS.CHANGESTEP,
        }),
        ...mapActions("authentication", {
            RESET: AUTHENTICATION__ACTIONS.RESET,
            CODEVERIFY: AUTHENTICATION__ACTIONS.CODEVERIFY,
            PASSRESET: AUTHENTICATION__ACTIONS.PASSRESET,
        }),
        ...mapActions("profile", [PROFILE__ACTIONS.GETPROFILE]),

        changeNextStep(step) {
            this.CHANGESTEP(step);
        },

        handleReset() {
            this.RESET();
        },

        handleCodeVerify() {
            this.CODEVERIFY();
        },

        handlePassReset() {
            this.PASSRESET();
        },

        onCopy(event) {
            event.preventDefault();
        },

        onPaste(event) {
            event.preventDefault();
        },

        resendOTP() {
            this.handleReset();
            this.countdownTime = 120;
        },

        startCountdown() {
            const timerInterval = setInterval(() => {
                if (this.countdownTime > 0) {
                    this.countdownTime -= 1;
                } else {
                    clearInterval(timerInterval);
                }
            }, 1000);
        },
    },
    async mounted() {
        await this[PROFILE__ACTIONS.GETPROFILE]();
        this.startCountdown();
        document.title = `Create Password | ${this.$store.state.company.generalInfo?.company_name}`;
    },
};
</script>
